var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.486911 2.86856L2.86734 0.488132L3.23843 0.117039L106.832 103.71C103.994 98.8051 101.224 93.5596 98.9623 88.4698C96.523 82.9803 94.6256 77.5645 93.9108 72.8987C93.2122 68.3382 93.5574 63.9013 96.4059 61.0528L99.1574 63.8044C97.6887 65.273 97.1026 68.0363 97.7572 72.3095C98.3956 76.4773 100.136 81.5286 102.518 86.8897C107.273 97.5895 114.389 109.096 119.499 116.42L117.823 117.824L116.419 119.5C109.095 114.391 97.5883 107.274 86.8885 102.52C81.5275 100.137 76.4762 98.3969 72.3083 97.7584C68.0351 97.1038 65.2718 97.69 63.8032 99.1586L61.0517 96.4071C63.9001 93.5587 68.337 93.2134 72.8975 93.9121C77.5634 94.6268 82.9791 96.5243 88.4686 98.9636C93.5584 101.225 98.8039 103.995 103.709 106.833L0.115818 3.23965L0.486911 2.86856Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionRightArrow);
export default __webpack_public_path__ + "static/media/union_right_arrow.854c98d53ee187ce551745d454056270.svg";
export { ForwardRef as ReactComponent };